import { GET_DEFERRED_MESSAGES, TOGGLE_DEFERRED_SHOWN } from '../../../types/conversations'

const initialState = {
  messages: [],
  shouldShow: false
}

export default function deferred(state = initialState, action) {
  switch (action.type) {
    case GET_DEFERRED_MESSAGES: {
      return Object.assign({}, state, { messages: action.messages, shouldShow: action.messages.length > 0 })
    }
    case TOGGLE_DEFERRED_SHOWN: {
      const newShouldShow = !state.shouldShow
      return Object.assign({}, state, { shouldShow: newShouldShow })
    }
    default: {
      return state
    }
  }
}